<template>
  <div class="header-wrapper">
    <Banner />

    <div class="header">
      <div class="container">
        <div class="header__middle">
          <a href="/">
            <img
              v-if="mq.xsPlus"
              src="@/assets/images/logo.svg"
              class="header__logo"
            />

            <img
              v-else
              src="@/assets/images/monogram.svg"
              class="header__logo--small"
            />
          </a>
        </div>

        <div class="header__left">
          <IconButton
            class="header__icon header__icon--no-padding-left"
            data-testid="burger-menu"
            icon="burger"
            @click="mq.mdPlus ? setNavOpen(true) : toggleMobileMenu()"
          >
            <span class="u__hide--mobile header__text">MENU</span>
          </IconButton>
          <IconButton
            :tag="mq.mdPlus ? 'button' : 'a'"
            class="header__icon"
            data-testid="search"
            icon="search"
            :href="mq.mdPlus ? '' : '/search'"
            @click="mq.mdPlus ? setSearchOpen(true) : null"
          >
            <span class="u__hide--mobile header__text">SEARCH</span>
          </IconButton>
        </div>

        <div class="header__right">
          <IconButton
            :tag="isLoggedIn ? 'a' : 'button'"
            class="header__icon"
            icon="account"
            :href="isLoggedIn ? accountUrl : ''"
            @click="!isLoggedIn && setAccountOpen(true)"
          >
            <span class="u__hide--mobile header__text">ACCOUNT</span>
          </IconButton>

          <IconButton
            class="header__icon"
            icon="bag"
            @click="setCartOpen(true)"
          >
            <span class="u__hide--mobile header__text">BAG</span>
          </IconButton>
        </div>
      </div>
    </div>
  </div>

  <BurgerMenu v-if="isBurgerMenuOpen" />
  <BagV2 />
  <Search v-if="mq.mdPlus" />
  <LoginPanel />
  <DesktopNavigation v-if="mq.mdPlus" />
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import IconButton from "@/components/IconButton.vue";
import Banner from "@/components/Banner.vue";

import BagV2 from "@/components/BagV2.vue";
import Search from "@/components/SearchDesktop.vue";
import LoginPanel from "@/components/LoginPanel.vue";
import DesktopNavigation from "@/components/navigation/DesktopNavigation.vue";
import BurgerMenu from "@/components/BurgerMenu.vue";

export default {
  name: "HeaderComponent",
  components: {
    IconButton,
    BagV2,
    BurgerMenu,
    LoginPanel,
    Banner,
    DesktopNavigation,
    Search,
  },
  inject: ["mq"],
  computed: {
    ...mapState("app", ["isBurgerMenuOpen"]),
    ...mapState("auth", ["multipassAccount"]),
    ...mapGetters("auth", ["isLoggedIn"]),
    accountUrl() {
      return this.multipassAccount.url || "/account/login";
    },
    isTemplateIndex() {
      return document
        .querySelector("#app")
        .classList.contains("template-index");
    },
  },
  methods: {
    ...mapActions("app", ["toggleMobileMenu", "setAccountOpen", "setNavOpen"]),
    ...mapActions("search", ["setSearchOpen"]),
    ...mapActions("cart", ["setCartOpen"]),
  },
};
</script>

<style lang="scss" scoped>
.header {
  background-color: $color-white;
  height: 48px;

  & > .container {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 20px;
  }

  @include respond-above(md) {
    position: relative;
    height: auto;
  }

  &__middle {
    flex: 1 0 auto;
    order: 1;
    text-align: center;
  }

  &__left,
  &__right {
    flex: 0 1 auto;

    @include respond-above(md) {
      flex: 1 1 0;
    }
  }

  &__left {
    display: flex;
    align-items: center;
    order: 0;
  }

  &__right {
    display: flex;
    justify-content: flex-end;
    order: 2;
    text-align: right;

    @include respond-above(md) {
      -webkit-justify-content: flex-end;
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    font-size: 24px;
    line-height: 1;
    padding: 12px;
    @include respond-above(md) {
      padding: 10px;
      &--no-padding-left {
        padding-left: 0;
      }
    }
  }

  ::v-deep(.button--icon--has-text .icon) {
    @include respond-below(md) {
      margin-right: 0;
    }
  }

  &__logo {
    vertical-align: top;
    padding: 15px 0;

    &--small {
      max-width: 24px;
      align-items: center;
      display: flex;
    }

    &--medium {
      max-width: 35px;
      align-items: center;
      display: flex;

      @include respond-above(md) {
        max-width: 50px;
      }
    }
  }

  &__text {
    @include t__utility-label-20;
  }
}

.template-index .header {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0) 100%
  );

  * {
    transition: 0.2s;
  }

  *,
  ::v-deep(button) {
    color: $color-white !important;
  }

  .header__logo {
    filter: invert(1);
    &--small,
    &--medium {
      filter: invert(1);
    }
  }
}
</style>

<style lang="scss">
.fixed-header {
  padding-top: 83px;

  &.template-index {
    padding-top: 34px;

    @include respond-above(md) {
      padding-top: 36px;
    }
  }

  .header-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 4;
  }
}

.header__left {
  .button--icon:first-child {
    margin-left: -7px;
  }
}

.header__right {
  .button--icon:last-child {
    margin-right: -7px;
  }
}
</style>
